import { useState } from 'react';

export default function ProfileHeader() {
  const [isEditing, setIsEditing] = useState(false);
  const [userData, setUserData] = useState({
    name: 'Priya Sharma',
    email: 'priya.sharma@email.com',
    phone: '+91 98765 43210',
    address: '123 Green Valley, Mumbai, Maharashtra 400001'
  });

  const handleSave = () => {
    setIsEditing(false);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-8">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-6">
          <div className="w-24 h-24 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full flex items-center justify-center text-white text-3xl font-bold">
            {userData.name.split(' ').map(n => n[0]).join('')}
          </div>
          <div>
            {isEditing ? (
              <input
                type="text"
                value={userData.name}
                onChange={(e) => setUserData({...userData, name: e.target.value})}
                className="text-2xl font-bold text-gray-900 border-b-2 border-emerald-500 focus:outline-none mb-2"
              />
            ) : (
              <h1 className="text-2xl font-bold text-gray-900">{userData.name}</h1>
            )}
            <p className="text-gray-600 mt-1">Member since January 2024</p>
          </div>
        </div>
        <button
          onClick={() => isEditing ? handleSave() : setIsEditing(true)}
          className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {isEditing ? 'Save Changes' : 'Edit Profile'}
        </button>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">Email</label>
          {isEditing ? (
            <input
              type="email"
              value={userData.email}
              onChange={(e) => setUserData({...userData, email: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm"
            />
          ) : (
            <p className="text-gray-900">{userData.email}</p>
          )}
        </div>
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">Phone</label>
          {isEditing ? (
            <input
              type="tel"
              value={userData.phone}
              onChange={(e) => setUserData({...userData, phone: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm"
            />
          ) : (
            <p className="text-gray-900">{userData.phone}</p>
          )}
        </div>
        <div className="md:col-span-2">
          <label className="text-sm font-medium text-gray-700 block mb-2">Delivery Address</label>
          {isEditing ? (
            <textarea
              value={userData.address}
              onChange={(e) => setUserData({...userData, address: e.target.value})}
              rows={2}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm"
            />
          ) : (
            <p className="text-gray-900">{userData.address}</p>
          )}
        </div>
      </div>
    </div>
  );
}
